import { apiPost } from '../../api'

export const create_program = data => {
  return apiPost({
    endpoint: 'programs/create_program',
    data: data
  })
}
